import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getHomeStatGunStatus } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
import homeDataBlock from "../home-data-block/home-data-block.vue";
import homeDataTimeType from "../home-data-time-type/home-data-time-type.vue";
import { State } from "vuex-class";
let PiHomeDataAnnular = class PiHomeDataAnnular extends Vue {
    constructor() {
        super(...arguments);
        this.myChartIsSuccess = false;
        this.isActivated = true;
        this.loading = true;
        this.boxTitle = i18n.t("homeData.gunStatusTitle") + "";
        this.chargeEchart = {};
        this.myChart = {};
        this.win = window;
        this.echartData = [];
    }
    getVisible() {
        this.resizeBox();
    }
    getVisible2() {
        this.getHomeStatGunStatus();
    }
    resizeBox() {
        if (this.myChart.id && this.isActivated) {
            this.myChart.resize();
        }
    }
    async getHomeStatGunStatus() {
        this.loading = true;
        const ret = await getHomeStatGunStatus({ oprPkId: this.oprPkId });
        if (ret.status == this["$config"].apiStatus) {
            // const data: objAny = ret.data || {};
            this.echartData = ret.data || [];
            this.initEchart();
        }
        this.loading = false;
    }
    initEchart() {
        // 饼图
        const nameArr = [];
        const valueArr = [];
        this.echartData.map((item) => {
            if (item.id !== "9") {
                // 暂时去掉预约
                nameArr.push(item.name);
                valueArr.push(item.value);
            }
        });
        const series = [
            {
                name: this.boxTitle,
                type: "pie",
                radius: ["55%", "80%"],
                center: ["18%", "50%"],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: "center",
                },
                labelLine: {
                    show: false,
                },
                data: this.echartData,
            },
        ];
        const option = {
            tooltip: {
                trigger: "item",
            },
            legend: {
                orient: "vertical",
                itemWidth: 10,
                itemHeight: 10,
                itemGap: 20,
                icon: "rect",
                textStyle: {
                    rich: {
                        a: {
                            fontSize: 12,
                            color: "rgba(255,255,255,0.8)",
                        },
                        b: {
                            fontSize: 12,
                            color: "#ffffff",
                            width: 40,
                        },
                    },
                },
                left: "38%",
                top: "10%",
                data: nameArr,
                formatter: (name) => {
                    const i = nameArr.indexOf(name);
                    const arr = ["{a| " + name + "}", "{b| " + valueArr[i] + "}"];
                    return arr.join("");
                },
            },
            color: [
                "#FFFF00",
                "#0000FF",
                "#FF0000",
                "#000000",
                "#666666",
                "#00FF00",
                "#FFA500",
                "#6442FF",
            ],
            series: series,
        };
        if (Object.keys(this.myChart).length != 0) {
            this.myChart.dispose();
        }
        this.myChart = this.win.echarts.init(this.chargeEchart);
        this.myChart.clear();
        this.myChart.setOption(option, true);
    }
    mounted() {
        this.$nextTick(() => {
            this.chargeEchart = this.$refs.echart || {};
            this.getHomeStatGunStatus();
        });
    }
    deactivated() {
        this.isActivated = false;
    }
    activated() {
        let echart = this.$refs.echart;
        if (echart) {
            const secondChild = echart.children[1]; // 注意索引从 0 开始
            if (echart.innerHTML === "" ||
                (secondChild && secondChild.innerHTML === "")) {
                this.getHomeStatGunStatus();
            }
        }
        this.isActivated = true;
    }
};
__decorate([
    Prop({ default: "" })
], PiHomeDataAnnular.prototype, "oprPkId", void 0);
__decorate([
    State("sys")
], PiHomeDataAnnular.prototype, "sys", void 0);
__decorate([
    Watch("sys.winOnresize")
], PiHomeDataAnnular.prototype, "getVisible", null);
__decorate([
    Watch("oprPkId")
], PiHomeDataAnnular.prototype, "getVisible2", null);
PiHomeDataAnnular = __decorate([
    Component({
        components: {
            "pi-home-data-block": homeDataBlock,
            "pi-home-data-time-type": homeDataTimeType,
        },
    })
], PiHomeDataAnnular);
export default PiHomeDataAnnular;
